import React, { useState } from "react";
import ConfirmModal from "../ConfirmModal";
import { updateReportSectionState } from "../../api/api";

export const SectionStateToggle = ({ section, onStateChange, requireConfirm = false }) => {
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // Local state initialized from prop only once
  const [localState, setLocalState] = useState(section.state);

  const newState = localState === "ready" ? "not_started" : "ready";

  const toggleState = async () => {
    setShowConfirm(false);
    setLoading(true);

    // Update local state immediately
    setLocalState(newState);
    onStateChange(section.id, newState);

    try {
      await updateReportSectionState(section.id, newState);
    } catch (err) {
      console.error("Failed to update section state", err);
      // revert local + parent state on failure
      setLocalState(section.state);
      onStateChange(section.id, section.state);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    if (loading) return;

    if (requireConfirm) setShowConfirm(true);
    else toggleState();
  };

  return (
    <>
      <span
        className="section-state-toggle"
        onClick={handleClick}
        style={{
          cursor: loading ? "not-allowed" : "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          transition: "transform 0.15s, opacity 0.15s",
          opacity: loading ? 0.5 : 0.85,
        }}
        onMouseEnter={e => { if (!loading) { e.currentTarget.style.transform = 'scale(1.25)'; e.currentTarget.style.opacity = '1'; } }}
        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.opacity = loading ? '0.5' : '0.85'; }}
        onMouseDown={e => { if (!loading) e.currentTarget.style.transform = 'scale(0.95)'; }}
        onMouseUp={e => { if (!loading) e.currentTarget.style.transform = 'scale(1.25)'; }}
      >
        {localState !== "ready" ? (
          <i
            className="bi bi-shield-fill-exclamation text-warning fs-5"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Merkitse osio valmiiksi"
            style={{ textShadow: "0 0 3px rgba(0,0,0,1.5)" }}
          />
        ) : (
          <i
            className="bi bi-shield-fill-check text-success fs-5"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Merkitse osio keskeneräiseksi"
            style={{ textShadow: "0 0 3px rgba(0,0,0,1.5)" }}
          />
        )}
      </span>

      {requireConfirm && (
        <ConfirmModal
          show={showConfirm}
          onClose={() => setShowConfirm(false)}
          onConfirm={toggleState}
          title="Vahvista muutos"
          message={`Haluatko merkitä osion "${section.name}" ${
            localState === "ready" ? "keskeneräiseksi" : "valmiiksi"
          }?`}
          confirmText="Kyllä, jatka"
          cancelText="Peru"
          confirmVariant="success"
        />
      )}
    </>
  );
};